import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/attention.svg',
})
export class ProfileComponent {}
